<template><div><h1 id="ftml-datenbearbeitung" tabindex="-1"><a class="header-anchor" href="#ftml-datenbearbeitung"><span>FTML-Datenbearbeitung</span></a></h1>
<p>FTML Datenverarbeitung — Regiezentrum für die FTML Verarbeitung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In der Maske FTML-Datenverarbeitung können die eingelesenen Transaktionen zur weiteren Verarbeitung freigegeben, abgelehnt und verarbeitet werden. Funktionen zur Änderung der Adresse, zur Ansicht des XML Quellcodes sind ebenfalls vorhanden.</p>
<h3 id="status-einer-transaktion" tabindex="-1"><a class="header-anchor" href="#status-einer-transaktion"><span>Status einer Transaktion</span></a></h3>
<p>FTML Transaktionen können verschiedene Stati haben. Der Status zeigt, in welchem Verarbeitungszustand sich eine Transaktion befindet und gibt ev. Probleme beim Verarbeiten der Transaktion an.</p>
<p>Der Status besteht aus zwei Teilen. Der erste Teil ist der Hauptstatus, und der zweite Teil gibt weitere Informationen zum Hauptstatus. Die folgende Tabelle listst die möglichen Statuskombinationen auf.</p>
<p><strong>Tabelle 39. Stati von FTML Transaktionen</strong></p>
<table>
<thead>
<tr>
<th>Hauptstatus</th>
<th>Nebenstatus</th>
<th>Erklärung</th>
</tr>
</thead>
<tbody>
<tr>
<td>OK</td>
<td>Aut</td>
<td>Die Transaktion wurde vom System validiert und ist bereit zur Verarbeitung.</td>
</tr>
<tr>
<td>OK</td>
<td>Man</td>
<td>Die Transaktion wurde manuell auf OK gesetzt.</td>
</tr>
<tr>
<td>NOK</td>
<td>Nummer</td>
<td>Das System findet, dass die Transaktion nicht plausibel ist. Durch die Nummer wird genauer spezifiziert, was das Problem mit der Transaktion ist. Dieser Status kann entweder direkt nach dem Einlesen vom System gesetzt werden oder kann auch erst nach einem Verarbeitungsversuch, der nicht geglückt ist, entstehen. In der Detailansicht wird die Nummer mit einem Text ergänzt.</td>
</tr>
<tr>
<td>verarbeitet</td>
<td></td>
<td>Die Transaktion wurde erfolgreich verarbeitet (d.h. im System ausgeführt). Dieser Status ist der normale Endstatus der Transaktion und kann nicht mehr geändert werden.</td>
</tr>
<tr>
<td>abgelehnt</td>
<td></td>
<td>Die Transaktion wurde manuell abgelehnt und soll nicht weiter verarbeitet werden.</td>
</tr>
</tbody>
</table>
<h3 id="ftml-transaktionen-und-ihre-abbildung-in-funtrade" tabindex="-1"><a class="header-anchor" href="#ftml-transaktionen-und-ihre-abbildung-in-funtrade"><span>FTML Transaktionen und ihre Abbildung in funtrade</span></a></h3>
<p>In diesem Abschnitt werden die einzelnen Transaktionstypen und ihre Auswirkungen auf funtrade besprochen.</p>
<dl>
<dt>Registration,</dt>
<dd>Registration</dd>
<dt>ANM</dt>
<dd>Peer to Peer Kampagne</dd>
<dt>P2PCampaign,</dt>
<dd>Ein I-Ereignis wird erfasst.</dd>
<dt>CMP</dt>
<dd>Diese Transaktionen werden nicht verarbeitet.</dd>
<dt>Visit,</dt>
<dd>Main</dd>
<dt>CMP</dt>
<dd>Diese Transaktionen werden gar nicht verarbeitet, sie können von den Benutzern angesehen und manuell verarbeitet werden.</dd>
<dt>Generic,</dt>
<dd>Das System erfasst eine <span class="guilabel">Neue Adresse</span>.</dd>
<dt>CMP</dt>
<dd>Das Subscription Element erfasst Extra-Publikationen bei der Adresse. Auch in dem Fall, dass eine Adresse eine bestimmte Publikation bereits vom Regelwerk her bekommt, wird eine Extra-Publikation erfasst.</dd>
<dt>Main,</dt>
<dd>Eine Spendentransaktion wird je nach Zahlungsart unterschiedlich abgebildet.<br>Bei Spenden, die bereits Online bezahlt wurden (Payment=External), wird direkt eine Spenden-, eine Zahlunsgbuchung und ein Response-Ereignis erfasst. Die Kontierung der Zahlungsbuchung ist kundenspezifisch und hängt von der Zahlungsart ab.<br>Bei Spenden mit Zahlungsart <span class="quote">„<span class="quote">Invoice</span>“</span> wird nur eine Korrespondenz erfasst. Der Korrespondenztyp der freie Text 1 werden in der Tabelle &quot;Korrespondenzen bei ESR Spenden&quot; definiert.</dd>
<dt>MAIN</dt>
<dd>Ein entsprechender Auftrag wird erfasst.<br>Im Systemparameter wwvk ist die Auftragsart, die Bestellart und das Medium definiert. Alle anderen relevanten Daten kommen aus der FTML Quelle.</dd>
<dt>Request,</dt>
<dd>Die Zusagentransaktion erfasst eine neue Zusage vom angegebenen Typ. Im Falle, dass FirstPayment vorhanden ist (Zahlung der ersten Rate online), wird wie bei Donation eine Zahlung erfasst.</dd>
<dt>MSG,</dt>
<dd>undefined</dd>
<dt>Anfrage</dt>
<dd>undefined</dd>
<dt>AddressChange,</dt>
<dd>undefined</dd>
<dt>MUT,</dt>
<dd>undefined</dd>
<dt>Adressänderung</dt>
<dd>undefined</dd>
<dt>Subscription,</dt>
<dd>undefined</dd>
<dt>PUB,</dt>
<dd>undefined</dd>
<dt>Publikation</dt>
<dd>undefined</dd>
<dt>Donation,</dt>
<dd>undefined</dd>
<dt>SPE,</dt>
<dd>undefined</dd>
<dt>Spende</dt>
<dd>undefined</dd>
<dt>Order,</dt>
<dd>undefined</dd>
<dt>WVK,</dt>
<dd>undefined</dd>
<dt>Auftrag</dt>
<dd>undefined</dd>
<dt>PledgeDonation,</dt>
<dd>undefined</dd>
<dt>ZUS,</dt>
<dd>undefined</dd>
<dt>Zusage</dt>
<dd>undefined</dd>
</dl>
<p>Pfad: <code v-pre>Datenaustausch → FTML Datenbearbeitung</code></p>
<h2 id="datenfelder-filter" tabindex="-1"><a class="header-anchor" href="#datenfelder-filter"><span>Datenfelder (Filter)</span></a></h2>
<dl>
<dt>Datum von/bis</dt>
<dd>Einschränkung der Transaktionen nach einem Zeitraum.</dd>
<dt>Checkbox &quot;nur pendente&quot;</dt>
<dd>Angehakt werden nur pendente Transationen angezeigt.</dd>
<dt>Transaktionstyp</dt>
<dd>Filter nach Transaktionytyp</dd>
<dt>Personen-ID</dt>
<dd>Filter nach Personen-ID</dd>
<dt>Transaktion</dt>
<dd>Filter nach einer spezifischen Transaktion</dd>
<dt>Transaktionsinhalt</dt>
<dd>Filtert Transaktionen nach einem bestimmten Ausdruck in der ganzen Transaktion</dd>
<dt>Quelle</dt>
<dd>Filterung nach Quelle</dd>
</dl>
<h2 id="datenfelder-transaktionen" tabindex="-1"><a class="header-anchor" href="#datenfelder-transaktionen"><span>Datenfelder (Transaktionen)</span></a></h2>
<dl>
<dt>Datum/Zeit</dt>
<dd>Datum und Zeit der Transaktion (aus FTML). Das Datum des Imports spielt keine Rolle.</dd>
<dt>Transaktion</dt>
<dd>Nummer der Transaktion wie sie vom externen System geliefert wurde.</dd>
<dt>Inhalt</dt>
<dd>Inhalt der Transaktion, siehe oben Transkationstypen. Eine Transaktion kann mehrere Transaktionen (Typ) beinhalten.</dd>
<dt>Name/Adresse</dt>
<dd>Name, Vorname, Ort der Person so wie die Daten im Web eingegeben wurden. In Klammer steht die Personen-ID, wenn die Person in <span class="emphasis"><em><span class="application">funtrade</span></em></span> gefunden wurde.<br>Wurde eine Person manuell zugeordnet, dann werden Name, Vorname und Ort der Adresse aus <span class="emphasis"><em><span class="application">funtrade</span></em></span> angegeben.</dd>
<dt>Status</dt>
<dd>Der Status der Transaktion. Siehe oben.</dd>
</dl>
<h2 id="datenfelder-rechtes-frame" tabindex="-1"><a class="header-anchor" href="#datenfelder-rechtes-frame"><span>Datenfelder (rechtes Frame)</span></a></h2>
<dl>
<dt>Pos.</dt>
<dd>Positionen der Transaktion</dd>
<dt>Typ</dt>
<dd>Transaktionstyp aus der Transaktion, siehe oben Transaktionstypen</dd>
<dt>Inhalt</dt>
<dd>Inhalt der Transaktion, siehe oben Transkationstypen. Eine Transaktion kann mehrere Transaktionen (Typ) beinhalten.</dd>
<dt>Status</dt>
<dd>Der Status der einzelnene Transaktion. Siehe oben.</dd>
<dt>Status</dt>
<dd>Der Status der Transaktion. Siehe oben.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="person-erfassen-und-zuordnen" tabindex="-1"><a class="header-anchor" href="#person-erfassen-und-zuordnen"><span>Person erfassen und zuordnen...</span></a></h3>
<p>Damit kann die Person erfasst und zu dieser Transaktion zugeordnet werden, falls die Person nicht bereits in funtrade erfasst ist.</p>
<h3 id="ftml-daten-importieren" tabindex="-1"><a class="header-anchor" href="#ftml-daten-importieren"><span>FTML-Daten importieren...</span></a></h3>
<p>Mit dieser Funktion werden die FTML-Daten importiert.</p>
<h3 id="transaktionen-verarbeiten" tabindex="-1"><a class="header-anchor" href="#transaktionen-verarbeiten"><span>Transaktionen verarbeiten...</span></a></h3>
<p>Damit können alle Transaktionen verarbeitet werden, bei Bedarf können auch nur bestimmte Typen verarbeitet werden (Einschränkung nach Typ).</p>
<h3 id="einzelne-transaktion-verarbeiten" tabindex="-1"><a class="header-anchor" href="#einzelne-transaktion-verarbeiten"><span>Einzelne Transaktion verarbeiten...</span></a></h3>
<p>Mit dieser Option können einzelne Transaktionen verarbeitet werden.</p>
<h3 id="ftml-daten-exportieren" tabindex="-1"><a class="header-anchor" href="#ftml-daten-exportieren"><span>FTML-Daten exportieren...</span></a></h3>
<p>Mit dieser Funktion können die FTML-Daten exportiert werden.</p>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Druckt die Transaktionen aus.</p>
<h3 id="sortierung" tabindex="-1"><a class="header-anchor" href="#sortierung"><span>Sortierung</span></a></h3>
<p>Die Daten können nach den Spalten Datum/Zeit oder Transaktion sortiert werden.</p>
<h3 id="transaktions-status-andern-rechtes-frame" tabindex="-1"><a class="header-anchor" href="#transaktions-status-andern-rechtes-frame"><span>Transaktions-Status ändern... (rechtes Frame)</span></a></h3>
<p>Eine Transaktion kann abgelehnt, der Status auf OK oder NOK gesetzt werden.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/ftml.html" title="4. FTML (E-Commerce)">FTML Anleitung</RouteLink></p>
<p><RouteLink to="/referenz/refs/ft.refproc.ftmlimport.html" title="FTML Import">FTML Import</RouteLink></p>
</div></template>


